// import Horizontal_scroll_view from '../horizontal_scroll_view';
import React, { useEffect, useState } from 'react';
import { getPropertyValueInPixels, isSmartPhone } from '../../utilities/helper';
import GamesPosterCard from '../games_poster_card';
import HorizontalScroll from '../horizontal_scroll_view';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import './index.css';
import useInViewPort from '../../hooks/useInViewPort';

const GamesPoster = ({ games, gameClickHandler, id }: any) => {
  const onGamePosterClick = (item: any) => {
    gameClickHandler(item);
  };
  const [isRightArrowVisible, setRightArrowVisible] = useState(false);
  const [isLeftArrowVisible, setLeftArrowVisible] = useState(false);

  const slideLeft = (elementId: string) => {
    const container = document.getElementById(elementId) as HTMLInputElement;
    const scrollPixels =
      getPropertyValueInPixels(container, 'width') -
      getPropertyValueInPixels(container, 'padding-left') -
      getPropertyValueInPixels(container, 'padding-right');
    const currentPosition = container.scrollLeft;
    container.scroll({
      left: currentPosition - scrollPixels,
      behavior: 'smooth'
    });
  };
  const slideRight = (elementId: string) => {
    const container = document.getElementById(elementId) as HTMLInputElement;
    const scrollPixels =
      getPropertyValueInPixels(container, 'width') -
      getPropertyValueInPixels(container, 'padding-left') -
      getPropertyValueInPixels(container, 'padding-right');
    const currentPosition = container.scrollLeft;
    container.scroll({
      left: scrollPixels + currentPosition,
      behavior: 'smooth'
    });
  };
  const handleScroll = () => {
    const baseElement = Array.from(document.getElementsByClassName('horizontalScroll__wrapper'));
    const currentElement = baseElement.find((ele) => ele.id == id);
    if (currentElement) {
      const childCollection = currentElement.getElementsByClassName('games_poster_container');
      Array.from(childCollection).forEach((ele, idx) => {
        if (idx === childCollection.length - 1) {
          if (useInViewPort(ele)) {
            setRightArrowVisible(false);
          } else {
            setRightArrowVisible(true);
          }
        }
        if (idx === 0) {
          if (useInViewPort(ele)) {
            setLeftArrowVisible(false);
          } else {
            setLeftArrowVisible(true);
          }
        }
      });
    }
  };
  useEffect(() => {
    const baseElement = Array.from(document.getElementsByClassName('horizontalScroll__wrapper'));
    const currentElement = baseElement.find((ele) => ele.id == id);
    currentElement?.addEventListener('scroll', handleScroll);

    return () => {
      if (currentElement) {
        currentElement.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);
  return (
    <HorizontalScroll isDesktop id={id}>
      {!isSmartPhone && (
        <>
          <span
            style={{
              visibility: !isLeftArrowVisible ? 'hidden' : 'visible',
              height: '200px'
            }}
            className="gamesCategory__sliderArrow__web gamesCategory__sliderLeftArrow__web"
            onClick={() => slideLeft(id)}>
            <ArrowBackIosIcon fontSize="large" style={{ color: 'white' }} />
          </span>
          <span
            style={{
              visibility: !isRightArrowVisible ? 'hidden' : 'visible',
              height: '200px'
            }}
            className="gamesCategory__sliderArrow__web gamesCategory__sliderRightArrow__web"
            onClick={() => slideRight(id)}>
            <ArrowForwardIosIcon fontSize="large" style={{ color: 'white' }} />
          </span>
        </>
      )}
      <div className={`${isSmartPhone ? 'games_poster_wrapper_mWeb' : 'games_poster_wrapper'}`}>
        {games && games.length > 0 ? (
          games.map((item: any, idx: any) => (
            <React.Fragment key={idx}>
              <GamesPosterCard item={item} idx={idx} onGamePosterClick={onGamePosterClick} />
            </React.Fragment>
          ))
        ) : (
          <div
            style={{
              height: '250px',
              fontWeight: '900',
              color: 'white',
              textAlign: 'center',
              display: 'flex',
              justifyContent: 'center',
              paddingTop: '100px',
              width: '100%'
            }}>
            <p>Coming soon ....</p>
          </div>
        )}
      </div>
    </HorizontalScroll>
  );
};

export default GamesPoster;
